<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>Countries</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new country"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Countries</h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">

                    <b-button @click="showEditDialog(row.item)"
                              variant="secondary btn--icon"
                              v-b-tooltip.hover="'Edit Country'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>

                    <b-button :to="{name: 'regions.browse', params: {countryId: row.item.id}}"
                              variant="info btn--icon"
                              v-b-tooltip.hover="'View Regions'">
                        <i class="zmdi zmdi-chevron-right"></i>
                    </b-button>

                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" :country="editingCountry" v-model="editingCountry" v-if="editingCountry" />
    </div>
</template>

<script>
import listCountriesQuery from '@views/Countries/Browse/queryListCountries.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseCountries',
  apollo: {
    countries: {
      query: listCountriesQuery,
      variables: { input: { include_deleted: true } },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.countries = data.filterCountries.data;
          this.pagination.total = data.filterCountries.meta.total;
        }
      },
    },
  },
  data() {
    return {
      countries: [],
      editingCountry: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Country',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.countries || []).map(item => ({
        ...item,
      }));
    },
  },
  methods: {
    showEditDialog(country) {
      this.editingCountry = country;
    },
    closeEditDialog() {
      this.editingCountry = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
